export default "__VITE_ASSET__Dyx$EuUa__"